<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>{{info.className}}  学生托管报名详情</span>
            </div>
            <div class="right"></div>
        </div>
        <div>
            <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="">
                    <el-input v-model="queryParams.name" placeholder="请输入学生姓名"></el-input>
                </el-form-item>
				<el-form-item label="">
                    <el-input v-model="queryParams.title" placeholder="请输入课程名称"></el-input>
                </el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
            </el-form>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="studentName" label="学生姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="courseName" label="报名课程" align="center">
                    </el-table-column>
                    <el-table-column prop="signTime" label="报名时间" align="center">
                    </el-table-column>
                    <el-table-column prop="classTime" label="上课时间" align="center">
                    </el-table-column>
                    <el-table-column prop="locationName" label="上课地点" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
	props:['info'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
				title: '',
			},
			tableData: [
				{studentName:'衡锦舒',courseName:'作业辅导',signTime:'2021/6/8 2:47:00',classTime:'每周日17:10-17:50',locationName:'二年级5班'},
				{studentName:'范月园',courseName:'作业辅导',signTime:'2021/6/8 2:47:00',classTime:'每周一17:10-17:50',locationName:'二年级1班'},
				{studentName:'杭上慧',courseName:'智慧机器人',signTime:'2021/6/8 2:47:00',classTime:'每周二17:10-17:50',locationName:'二年级2班'},
				{studentName:'颜婕伊',courseName:'温暖美术',signTime:'2021/6/8 2:47:00',classTime:'每周三17:10-17:50',locationName:'一年级5班'},
				{studentName:'邬金无',courseName:'竞技篮球',signTime:'2021/6/8 2:47:00',classTime:'每周四17:10-17:50',locationName:'一年级5班'},
				{studentName:'林雁雁',courseName:'优美声乐',signTime:'2021/6/8 2:47:00',classTime:'每周五17:10-17:50',locationName:'一年级1班'},
				{studentName:'晋芸姣',courseName:'优美声乐',signTime:'2021/6/8 2:47:00',classTime:'每周日17:10-17:50',locationName:'二年级5班'},
			],
		}
	},
	computed:{

	},
	watch: {
		'info.classId':function(n,o){
			this.pageNum = 1;
			this.getDataList();
		},
	},
	created() {
		
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
				classId:this.info.classId,
				courseName:this.queryParams.title,
				studentName:this.queryParams.name,
			}
			// let res= await api.studentCourseStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum = 1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toIndex(){
            this.$emit('to-index')
        },
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
